import React, { useEffect, useRef } from 'react';

interface RootCloseWrapperProps {
  onRootClose?: (e: Event) => void;
  children: React.ReactElement;
  disabled?: boolean;
  event?: 'click' | 'mousedown';
}

const isLeftClickEvent = (event: MouseEvent) => event.button === 0;

const isModifiedEvent = (event: MouseEvent) =>
  !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);

const RootCloseWrapper: React.FC<RootCloseWrapperProps> = ({
  onRootClose,
  children,
  disabled,
  event = 'click',
}) => {
  const childRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!disabled) {
      const handleKeyUp = (e: KeyboardEvent) => {
        if (e.key === 'Escape' && onRootClose) {
          onRootClose(e);
        }
      };

      const handleMouse = (e: MouseEvent) => {
        const target = e.target as HTMLElement;

        if (
          !isModifiedEvent(e) &&
          isLeftClickEvent(e) &&
          childRef.current &&
          !childRef.current.contains(target) &&
          onRootClose
        ) {
          onRootClose(e);
        }
      };

      document.addEventListener(event, handleMouse, true);
      document.addEventListener('keyup', handleKeyUp);

      return () => {
        document.removeEventListener(event, handleMouse, true);
        document.removeEventListener('keyup', handleKeyUp);
      };
    }
  }, [disabled, event, onRootClose]);

  return <div ref={childRef}>{children}</div>;
};

export default RootCloseWrapper;
